// extracted by mini-css-extract-plugin
var _1 = "NavArrowButton-moduleNavArrowButton__PbEBW Button-modulebutton__AisLs Flat-moduleflat__s3eC8";
var _2 = "NavArrowButton-moduleicon__oUGTx IconNG-moduleiconContainer__SxWZ0";
export { _1 as "NavArrowButton", _2 as "icon" }
